<template>
  <section class="module-boxes">
    <div :class="{ container: isContainer }">
      <div
        class="columns"
        :class="{
          'block-box': !isInlineBox,
          'full-box': isFullBox,
          'box-wrap': isBoxWrap,
          'opinions-page': opinionsPage,
          'no-margin': noMargin,
          'mobile-bottom-info': mobileBottomInfo
        }"
      >
        <div
          v-for="(item, index) in boxItems"
          :key="index"
          class="column"
          :class="{
            'inline-box': isInlineBox,
            [countColumn]: isCountColumn,
            'is-4-tablet': oneThirdTablet,
            'is-6-tablet': isColumnTablet,
            'is-6-mobile': isColumnMobile,
            'is-12-tablet': isFullTablet,
            'is-12-mobile': isFullMobile
          }"
        >
          <MbBox
            :boxItems="item"
            :box-skieletors="boxSkieletors"
            :isDescription="isDescription"
            :isDescriptionText="isDescriptionText"
            :isAuthorBox="isAuthorBox"
            :isShared="isShared"
            :isWeekly="isWeekly"
            :hideBottomSection="hideBottomSection"
            :isNameOfDay="isNameOfDay"
            :imgWidth="imgWidth"
            :imgHeight="imgHeight"
            :opinionsPage="opinionsPage"
            :mobileBottomInfo="mobileBottomInfo || isWrapMobile"
            :categoryTwoBox="categoryTwoBox"
            :isCategoryBox="isCategoryBox"
            :categoryThreeBox="categoryThreeBox"
            :isPoliticInfoBox="isPoliticInfoBox"
            :isSmallPlay="isSmallPlay"
            :onlyTitle="onlyTitle"
            :min-height="minHeight"
            :isImage4x3="isImage4x3"
            :isRegionsBox="isRegionsBox"
            :showSeeMoreWhenDescriptionEmpty="showSeeMoreWhenDescriptionEmpty"
            :maxLineTitleFourBoxes="maxLineTitleFourBoxes"
            :maxLineTitleThreeBoxes="maxLineTitleThreeBoxes"
            :maxLineTitleTwoBoxes="maxLineTitleTwoBoxes"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { defineAsyncComponent, computed } from 'vue'

const MbBox = defineAsyncComponent(() => import('@/components/boxes/MbBox.vue'))

const props = defineProps({
  hideBottomSection: {
    type: Boolean,
    default: false
  },
  mbBoxItems: {
    type: Number,
    default: 0
  },
  isInlineBox: {
    type: Boolean,
    default: false
  },
  isShared: {
    type: Boolean,
    default: true
  },
  isCountColumn: {
    type: Boolean,
    default: false
  },
  isColumnTablet: {
    type: Boolean,
    default: false
  },
  oneThirdTablet: {
    type: Boolean,
    default: false
  },
  isColumnMobile: {
    type: Boolean,
    default: false
  },
  maxLineTitleFourBoxes: {
    type: Boolean,
    default: false
  },
  maxLineTitleThreeBoxes: {
    type: Boolean,
    default: false
  },
  maxLineTitleTwoBoxes: {
    type: Boolean,
    default: false
  },
  isFullMobile: {
    type: Boolean,
    default: false
  },
  isFullTablet: {
    type: Boolean,
    default: false
  },
  isContainer: {
    type: Boolean,
    default: true
  },
  isFullBox: {
    type: Boolean,
    default: false
  },
  isBoxWrap: {
    type: Boolean,
    default: false
  },
  isRegionsBox: {
    type: Boolean,
    default: false
  },
  isDescription: {
    type: Boolean,
    default: true
  },
  isSmallPlay: {
    type: Boolean,
    default: false
  },
  isDescriptionText: {
    type: Boolean,
    default: true
  },
  mobileBottomInfo: {
    type: Boolean,
    default: false
  },
  isCategoryBox: {
    type: Boolean,
    default: false
  },
  categoryTwoBox: {
    type: Boolean,
    default: false
  },
  categoryThreeBox: {
    type: Boolean,
    default: false
  },
  isAuthorBox: {
    type: Boolean,
    default: false
  },
  isWeekly: {
    type: Boolean,
    default: false
  },
  isNameOfDay: {
    type: Boolean,
    default: false
  },
  opinionsPage: {
    type: Boolean,
    default: false
  },
  noMargin: {
    type: Boolean,
    default: false
  },
  isPoliticInfoBox: {
    type: Boolean,
    default: false
  },
  boxItems: {
    type: Object,
    default: () => ({})
  },
  boxSkieletors: {
    type: Object,
    default: () => ({})
  },
  imgWidth: {
    type: Number
  },
  imgHeight: {
    type: Number
  },
  onlyTitle: {
    type: Boolean,
    default: false
  },
  minHeight: {
    type: Boolean,
    default: true
  },
  isWrapMobile: {
    type: Boolean,
    default: false
  },
  isImage4x3: {
    type: Boolean,
    default: false
  },
  showSeeMoreWhenDescriptionEmpty: {
    type: Boolean,
    default: false
  }
})

const countColumn = computed(() => {
  return `is-` + 12 / `${props.mbBoxItems}` + `-desktop`
})
</script>

<style lang="scss">
@import '@/assets/scss/components/modules/module-boxes.scss';
</style>
